module.exports = __webpack_public_path__ + "static/companies-house-white-e329e4aba4ab1b7f66043672d7a396b7.png";